module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40d59a6d36dd479f7934cc35c3f6f795.png";